<app-slide id="cardDetailsSlide" [title]="cardDetailsHeading" [supportingText]="cardDetailsSubHeading"
    [slideNumber]="number" [active]="active" [slideCompleted]="complete" [finalSlide]="lastSlide">
    <div class="overlay" *ngIf="processingPayment">
        <div class="modal-dialog modal--waiting">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">{{processingPaymentTitle}}</h4>
                </div>
                <div class="modal-body">
                    <p>{{processingPaymentBody}}</p>
                    <div style="height: 50px; position: relative">
                        <!-- <span us-spinner spinner-key="paymentProcessingSpinner" spinner-start-active="true"></span> -->
                        <app-spinner></app-spinner>
                    </div>
                </div>
                <div class="modal-footer">
                </div>
            </div>
        </div>
    </div>
    <div id="error-failed-payment" class="alert alert-danger" *ngIf="showError">
        {{failedPaymentMessage}}
    </div>
    <div id="error" class="alert alert-danger" *ngIf="showException">
        {{errorPaymentMessage}}
    </div>
    <form [formGroup]="cardDetailsForm" (ngSubmit)="onSubmit()" novalidate autocomplete="off" class="card-details">
        <fieldset>
            <legend class="sr-only">{{ cardDetailsHeading }}</legend>
            <div class="section">
                <div class="row">
                    <div class="col-sm-6">
                        <p [innerHTML]="cardDetailsBodyWithAmount"></p>
                    </div>
                </div>
                <div class="form-card__poweredby">
                    <img src="/client/assets/your-housing-group/img/payments/poweredByWorldPay.gif"
                        alt="Powered by WorldPay" />
                </div>
                <!-- Validation errors section -->
                <div id="validation-errors" class="row">
                    <div class="col-sm-12 has-error">
                        <div *ngIf="cardDetailsForm.submitted">
                            <span *ngIf="!useDefaultAddress && !useCustomAddress" class="help-block"
                                style="line-height: 34px; vertical-align: middle; clear: both; margin-bottom: 0;">
                                <i class="fa fa-times-circle-o form-control-feedback"
                                    style="position: relative; float: left; margin-right: 5px;"></i>
                                Please select an address
                            </span>
                        </div>
                    </div>
                </div>
                <fieldset class="form-group" style="margin-bottom: 10px;">
                    <legend><strong>Card Holder Address</strong></legend>
                    <!-- DEFAULT -->
                    <div class="square_checkbox">
                        <input type="checkbox" id="my_address" formControlName="defaultAddress" class="sr-only"
                            (click)="toggleCheckbox('defaultAddress')" [checked]="addressType === 'DEFAULT'">
                        <label for="my_address" class="form-check-label">Use my address ({{ defaultAddress?.addressLine1
                            }} {{ defaultAddress?.addressLine2 }}, {{ defaultAddress?.postCode }})</label>
                    </div>
                    <!-- CUSTOM -->
                    <div class="square_checkbox">
                        <input type="checkbox" id="alternative_address" formControlName="customAddress" class="sr-only"
                            (click)="toggleCheckbox('customAddress')" [checked]="addressType === 'CUSTOM'">
                        <label for="alternative_address" class="form-check-label">Use a different billing
                            address</label>
                    </div>
                </fieldset>
                <!-- Address selection -->
                <div class="row" *ngIf="addressType === 'CUSTOM' && addressSubType === 'AUTO'">
                    <div class="col-sm-8">
                        <div [class.has-success]="cardDetailsForm.get('lookupPostcode')?.valid"
                            [class.has-error]="cardDetailsForm.get('lookupPostcode')?.invalid" class="form-group">
                            <label for="lookupPostcode">
                                <strong>Postcode</strong>
                            </label>
                            <div class="has-feedback lookup_field">
                                <input type="text" id="lookupPostcode" formControlName="lookupPostcode"
                                    class="form-control" [required]="addressSubType === 'AUTO'"
                                    (ngModelChange)="postcodeFailure=false" maxlength="8"
                                    style="text-transform: uppercase; width: calc(58.33333% - 15px); margin-right: 15px; float: left;" />
                                <button id="btn-address-find" type="button" class="btn btn-primary"
                                    [disabled]="cardDetailsForm.get('lookupPostcode')?.invalid || postcodeLookup === undefined || postcodeLookup === ''"
                                    (click)="getAddresses()">Find</button>
                                <span class="help-block has-error">
                                    <span
                                        *ngIf="cardDetailsForm.get('lookupPostcode')?.errors  && (cardDetailsForm.get('lookupPostcode')?.touched || cardDetailsForm.get('lookupPostcode')?.dirty)"
                                        class="help-block has-error">
                                        <span
                                            *ngIf="cardDetailsForm.get('lookupPostcode')?.errors?.['required']">Required</span>
                                        <span *ngIf="cardDetailsForm.get('lookupPostcode')?.errors?.['maxlength']">Max
                                            of 8
                                            characters</span>
                                        <span *ngIf="cardDetailsForm.get('lookupPostcode')?.errors?.['pattern']">Please
                                            enter a
                                            valid UK postcode</span>
                                    </span>
                                </span>
                            </div>
                            <a style="cursor:pointer;" *ngIf="!postcodeFailure && addresses?.length === 0"
                                (click)="setShowManualAddress()">Enter your address manually</a>
                            <a style="cursor:pointer;" *ngIf="postcodeFailure" (click)="setShowManualAddress()">Postcode
                                not found,
                                enter manually</a>
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="addressType === 'CUSTOM' && addressSubType === 'AUTO' && addresses?.length > 0">
                    <div class="col-sm-8">
                        <div class="form-group" style="margin-top: 10px;">
                            <label for="addressList"><strong>Select your address</strong></label>
                            <div class="has-feedback" [class.has-success]="!cardDetailsForm.get('addressList').errors"
                                [class.has-error]="cardDetailsForm.get('addressList').errors">
                                <select id="addressList" class="form-control" formControlName="addressList"
                                    (change)="setAddressSelected()">
                                    <option value="">Choose</option>
                                    <option *ngFor="let address of addresses; let idx = index" [ngValue]="idx">
                                        {{address.addressLine1}} {{address.addressLine2}}, {{address.city}},
                                        {{address.county}}, {{address.country}}</option>
                                </select>
                                <span
                                    *ngIf="cardDetailsForm.get('addressList').errors && (cardDetailsForm.get('addressList').dirty || cardDetailsForm.get('addressList').touched)">
                                    <span *ngIf="cardDetailsForm.get('addressList').errors.required">Required</span>
                                </span>
                            </div>
                            Can't find your address? <a style="cursor:pointer;" *ngIf="!postcodeFailure"
                                (click)="setShowManualAddress()">Enter manually</a>
                        </div>
                    </div>
                </div>
                <div *ngIf="addressType === 'CUSTOM' && addressSubType === 'MANUAL'">
                    <div class="row">
                        <div class="col-sm-4">

                            <div class="form-group" style="margin-bottom: 0;"
                                [class.has-success]="cardDetailsForm.controls.addressLine1.valid"
                                [class.has-error]="cardDetailsForm.controls.addressLine1.invalid && (cardDetailsForm.controls.addressLine1.dirty || cardDetailsForm.controls.addressLine1.touched)">
                                <label for="addressLine1" style="margin-bottom: 4px;"><strong>Address Line
                                        1</strong></label>
                                <p style="margin-top: 0;">House name or number</p>
                                <div class="has-feedback">
                                    <input type="text" id="addressLine1" class="form-control"
                                        formControlName="addressLine1" />
                                    <span
                                        *ngIf="cardDetailsForm.controls.addressLine1.invalid && (cardDetailsForm.controls.addressLine1.dirty || cardDetailsForm.controls.addressLine1.touched)"
                                        class="help-block has-error">
                                        <span
                                            *ngIf="cardDetailsForm.controls.addressLine1.errors?.required">Required</span>
                                        <span *ngIf="cardDetailsForm.controls.addressLine1.errors?.maxlength">Max of
                                            250
                                            characters</span>
                                        <span *ngIf="cardDetailsForm.controls.addressLine1.errors?.pattern">The
                                            field
                                            contains
                                            invalid characters</span>
                                    </span>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-8">

                            <div class="form-group"
                                [ngClass]="{'has-success': cardDetailsForm.controls.addressLine2.valid, 'has-error': cardDetailsForm.controls.addressLine2.invalid && (cardDetailsForm.controls.addressLine2.dirty || cardDetailsForm.controls.addressLine2.touched)}">
                                <label for="addressLine2"><strong>Address Line 2</strong></label>
                                <input type="text" id="addressLine2" class="form-control"
                                    formControlName="addressLine2" />
                                <div *ngIf="cardDetailsForm.controls.addressLine2.invalid && (cardDetailsForm.controls.addressLine2.dirty || cardDetailsForm.controls.addressLine2.touched)"
                                    class="help-block has-error">
                                    <span *ngIf="cardDetailsForm.controls.addressLine2.errors?.required">Required</span>
                                    <span *ngIf="cardDetailsForm.controls.addressLine2.errors?.maxlength">Max of 250
                                        characters</span>
                                    <span *ngIf="cardDetailsForm.controls.addressLine2.errors?.pattern">The field
                                        contains
                                        invalid characters</span>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-8">

                            <div class="form-group"
                                [ngClass]="{'has-success': cardDetailsForm.controls.addressLine3.valid, 'has-error': cardDetailsForm.controls.addressLine3.invalid && (cardDetailsForm.controls.addressLine3.dirty || cardDetailsForm.controls.addressLine3.touched)}">
                                <label for="addressLine3"><strong>Address Line 3</strong></label>
                                <input type="text" id="addressLine3" class="form-control"
                                    formControlName="addressLine3" />
                                <div *ngIf="cardDetailsForm.controls.addressLine3.invalid && (cardDetailsForm.controls.addressLine3.dirty || cardDetailsForm.controls.addressLine3.touched)"
                                    class="help-block has-error">
                                    <span *ngIf="cardDetailsForm.controls.addressLine3.errors?.required">Required</span>
                                    <span *ngIf="cardDetailsForm.controls.addressLine3.errors?.maxlength">Max of 350
                                        characters</span>
                                    <span *ngIf="cardDetailsForm.controls.addressLine3.errors?.pattern">The field
                                        contains
                                        invalid characters</span>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-8">
                            <div class="form-group"
                                [ngClass]="{'has-success': cardDetailsForm.controls.city.valid, 'has-error': cardDetailsForm.controls.city.invalid && (cardDetailsForm.controls.city.dirty || cardDetailsForm.controls.city.touched)}">
                                <label for="city"><strong>City</strong></label>

                                <input type="text" id="city" class="form-control" formControlName="city" />
                                <div *ngIf="cardDetailsForm.controls.city.invalid && (cardDetailsForm.controls.city.dirty || cardDetailsForm.controls.city.touched)"
                                    class="help-block has-error">
                                    <span *ngIf="cardDetailsForm.controls.city.errors?.required">Required</span>
                                    <span *ngIf="cardDetailsForm.controls.city.errors?.maxlength">Max of 80
                                        characters</span>
                                    <span *ngIf="cardDetailsForm.controls.city.errors?.pattern">The field contains
                                        invalid
                                        characters</span>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-8">
                            <div class="form-group"
                                [ngClass]="{'has-success': cardDetailsForm.controls.county.valid, 'has-error': cardDetailsForm.controls.county.invalid && (cardDetailsForm.controls.county.dirty || cardDetailsForm.controls.county.touched)}">
                                <label for="county"><strong>County</strong></label>

                                <input type="text" id="county" class="form-control" formControlName="county" />
                                <div *ngIf="cardDetailsForm.controls.county.invalid && (cardDetailsForm.controls.county.dirty || cardDetailsForm.controls.county.touched)"
                                    class="help-block has-error">
                                    <span *ngIf="cardDetailsForm.controls.county.errors?.required">Required</span>
                                    <span *ngIf="cardDetailsForm.controls.county.errors?.maxlength">Max of 50
                                        characters</span>
                                    <span *ngIf="cardDetailsForm.controls.county.errors?.pattern">The field contains
                                        invalid
                                        characters</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-8">
                            <div class="form-group"
                                [ngClass]="{'has-success': cardDetailsForm.controls.country.valid, 'has-error': cardDetailsForm.controls.country.invalid && (cardDetailsForm.controls.country.dirty || cardDetailsForm.controls.country.touched)}">
                                <label for="country"><strong>Country</strong></label>

                                <input type="text" id="country" class="form-control" formControlName="country" />
                                <div *ngIf="cardDetailsForm.controls.country.invalid && (cardDetailsForm.controls.country.dirty || cardDetailsForm.controls.country.touched)"
                                    class="help-block has-error">
                                    <span *ngIf="cardDetailsForm.controls.country.errors?.required">Required</span>
                                    <span *ngIf="cardDetailsForm.controls.country.errors?.maxlength">Max of 80
                                        characters</span>
                                    <span *ngIf="cardDetailsForm.controls.country.errors?.pattern">The field
                                        contains
                                        invalid
                                        characters</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="form-group"
                                [ngClass]="{'has-success': cardDetailsForm.controls.postcode.valid, 'has-error': cardDetailsForm.controls.postcode.invalid && (cardDetailsForm.controls.postcode.dirty || cardDetailsForm.controls.postcode.touched)}">
                                <label for="postcode"><strong>Postcode</strong></label>

                                <input type="text" id="postcode" class="form-control" formControlName="postcode" />
                                <div *ngIf="cardDetailsForm.controls.postcode.invalid && (cardDetailsForm.controls.postcode.dirty || cardDetailsForm.controls.postcode.touched)"
                                    class="help-block has-error">
                                    <span *ngIf="cardDetailsForm.controls.postcode.errors?.required">Required</span>
                                    <span *ngIf="cardDetailsForm.controls.postcode.errors?.maxlength">Max of 8
                                        characters</span>
                                    <span *ngIf="cardDetailsForm.controls.postcode.errors?.pattern">Please enter a
                                        valid
                                        UK
                                        postcode</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <div class="btn-set clearfix">
                        <button [disabled]="cardDetailsForm.invalid" type="submit" class="btn btn-primary btn-send"
                            id="btn-submit-card-details">
                            {{ paymentAmountText }}
                            <!-- <div>
                        <app-spinner></app-spinner>
                        </div> -->
                        </button>

                        <button type="button" class="btn btn-tertiary btn-back" (click)="onBack()">Back</button>
                    </div>
                </div>
            </div>
        </fieldset>
    </form>
</app-slide>